/* eslint-disable import/prefer-default-export */

import i18n from './i18n';

export function siteDescription(tld) {
  if (tld === 'ae') {
    return i18n.gettext(
      'Order high-quality takeaway online from top Dubai restaurants, fast delivery straight to your home or office',
    );
  }
  if (tld === 'au') {
    return i18n.gettext(
      'Order high-quality takeaway online from top Australian restaurants, fast delivery straight to your home or office',
    );
  }
  if (tld === 'hk') {
    return i18n.gettext(
      'Order high-quality takeaway online from top Hong-Kong restaurants, fast delivery straight to your home or office',
    );
  }
  if (tld === 'ie') {
    return i18n.gettext(
      'Order high-quality takeaway online from top Dublin restaurants, fast delivery straight to your home or office',
    );
  }
  if (tld === 'sg') {
    return i18n.gettext(
      'Order high-quality takeaway online from top Singapore restaurants, fast delivery straight to your home or office',
    );
  }
  if (tld === 'tw') {
    return i18n.gettext('metadescription.tw');
  }
  if (tld === 'kw') {
    return i18n.gettext('metadescription.kw');
  }
  return i18n.gettext(
    'Order high-quality takeaway online from top UK restaurants, fast delivery straight to your home or office',
  );
}
